var React = require('react');

export class Reviews extends React.Component {
  constructor (props) {
    super(props);

    this.getUserPendingReviews = this.getUserPendingReviews.bind(this);
    this.updateReview = this.updateReview.bind(this);
  }

  // Adding new endpoint to fetch reviews that either haven't been snoozed or are past the snooze time
  static getUserPendingReviewsWithSnooze (userSSOID, callback) {
    const url = '/v1/reviews/user/' + userSSOID + '/current';
    let sendOptions;
    const accessToken = PSSessions.Cookies('PSAccess');
    sendOptions = {
      context: this,
      cache: false,
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      }
    };
    $.ajax(sendOptions).always(function(data, textStatus, xhrObj){
      return callback(data, textStatus, xhrObj);
    });
  }

  static snoozePendingReview(reviewId, callback) {
    const url = '/v1/reviews/' + reviewId + '/skip';
    let sendOptions;
    const accessToken = PSSessions.Cookies('PSAccess');
    sendOptions = {
      context: this,
      cache: false,
      type: 'PUT',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      }
    };
    $.ajax(sendOptions).always(function (data, textStatus, xhrObj) {
      return callback(data, textStatus, xhrObj);
    });
  }

  static getUserPendingReviews (userSSOID, callback) {
    const url = '/v1/reviews/user/' + userSSOID + '?complete=false&public=false';
    let sendOptions;
    const accessToken = PSSessions.Cookies('PSAccess');
    sendOptions = {
      context: this,
      cache: false,
      type: 'GET',
      url: url,
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      }
    };
    $.ajax(sendOptions).always(function(data, textStatus, xhrObj){
      return callback(data, textStatus, xhrObj);
    });
  }

  static updateReview (reviewID, payloadStr, callback) {
    const accessToken = PSSessions.Cookies('PSAccess');
    $.ajax({
      url: '/v1/reviews/' + reviewID,
      context: this,
      data: payloadStr,
      cache: false,
      type: "PUT",
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      }
    }).always(function(data, textStatus, jqXHR) {
      if ("success"  === textStatus) {
        return callback(reviewID, textStatus, jqXHR);
      } else {
        return callback(data, textStatus, jqXHR);
      }
    });
  }

  render () {
    return null;
  }
}
